export default function initFaq() {
    // ==========================================================
    // FAQ
    // ==========================================================

    const faqSections = document.querySelectorAll("[data-faq]");

    faqSections.forEach((faq) => {
        const triggers = faq.querySelectorAll("[data-faq-trigger]");

        triggers.forEach((trigger) => {
            trigger.addEventListener("click", () => {
                const item = trigger.closest(".faq-section__item");

                if (!item) {
                    return;
                }

                const isOpen = item.classList.contains("is-open");

                item.classList.toggle("is-open", !isOpen);

                trigger.setAttribute("aria-expanded", String(!isOpen));
            });
        });
    });
}
